<template>
      <v-text-field
        v-model="currentValue"
        :id="attributeName"
        :label="label || attributeName"
        :prefix="prefix"
        :type="type"
        v-validate="rules"
        :data-vv-name="label"
        :error-messages="errors.collect(label)"
        :outlined="outlined"
        :append-outer-icon="appendOuterIcon ? iconButton : ''"
        required
        :disabled="disabled"
        @input="onInputChange"
        @click:append-outer="clickAppendOuter"
      />
  </template>
  
  <script>
  export default {
    name: "GenericAttributeInput",
    inject: ["$validator"],
  
    props: {
      value: {
        required: true
      },
      attributeName: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: ''
      },
      type: {
          type: String,
          default: 'text'
      },
      rules: {
          type: String,
          default: ''
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      appendOuterIcon: {
        type: Boolean,
        default: false,
      },
      prefix: {
        type: String,
        required: false,
        default: '$'
      },
      iconButton: {
        type: String,
        default: 'mdi-send',
      },
    },
  
    data() {
      return {
        currentValue: this.value,
      };
    },
  
    watch: {
      // Importante: Si el padre actualiza la prop 'value' externamente, actualizamos el local
      // Y RE-VALIDAMOS con el nuevo valor externo
      value(newVal) {
        // Solo actualizar si el valor externo es diferente al valor interno actual
        // para evitar bucles si el padre actualiza basado en el emit
        console.log(newVal, this.currentValue);
        var newValString = String(newVal)
         if (newValString !== this.currentValue) {
             this.currentValue = newValString;
             console.log(`Watcher: Prop 'value' actualizada a ${newValString} para ${this.attributeName}. Revalidando.`);
             // <-- DESCOMENTAR ESTA LÍNEA -->
             this.$validator.validate();
         } else {
              console.log(`Watcher: Prop 'value' actualizada, pero es igual al estado local ${this.currentValue} para ${this.attributeName}. No se revalida.`);
         }
      }
    },
  
    methods: {
      onInputChange(inputValue) {
        let processedValue = inputValue;
        if (this.type === 'number') {
            processedValue = parseFloat(inputValue);
            if (isNaN(processedValue)) {
               processedValue = inputValue === '' ? null : processedValue;
            }
        }
        // ... lógica para otros tipos ...
  
        // 1. Actualiza el estado local con el valor procesado
        this.currentValue = processedValue;
  
  
        // 2. Emitimos el nuevo valor al padre
        // (Esto puede disparar el watcher en el padre, que luego actualiza la prop 'value',
        // lo que a su vez disparará el watcher de este componente. La guarda en el watcher evita bucles.)
        this.$emit('update-attribute', {
          name: this.attributeName,
          value: this.currentValue
        });
         this.$validator.validate();
  
      },
      clickAppendOuter() {
        this.$emit('click-button-append', this.attributeName);
      },
      validate() {
          // Este método es llamado externamente (ej: por el padre) para forzar validación
          return this.$validator.validate();
      }
    },
   
  };
  </script>
  
  <style lang="scss" scoped>
  /* Estilos */
  </style>